import {EquityNotification} from "../EquityNotification";
import './RateTermRefinanceNotification.scss';

export class RateTermRefinanceNotification extends EquityNotification {

    static instance = ({
        template: require('./RateTermRefinanceNotification.html'),
        controller: ['$scope', '$location', RateTermRefinanceNotification],
        bindings: {
            notification: '<'
        }
    });

}